import { ComponentProps, useState } from 'react'
import { useCopyClipboard } from '@cocoonspace/shared/hooks/use-copy-clipboard.hook'
import { Button } from '@cocoonspace/ui/components/button'
import {
	Popover,
	PopoverContent,
	PopoverTrigger,
} from '@cocoonspace/ui/components/popover'
import { useLingui } from '@lingui/react/macro'
import { LinkIcon, ShareIcon } from 'lucide-react'

export const ShareBox = ({
	link,
	title,
	activatorClassName,
	buttonProps,
	onCopyBtnClick,
}: {
	title: string
	link?: string
	activatorClassName?: string
	buttonProps?: ComponentProps<typeof Button>
	onCopyBtnClick?: () => void
}) => {
	const { t } = useLingui()
	const [isOpen, setIsOpen] = useState(false)
	const { isCopied, copyToClipboard } = useCopyClipboard(2000)

	const currentPageLink =
		typeof window !== 'undefined' ? window.location.href : ''

	const linkTocopy = link ? link : currentPageLink

	return (
		<Popover
			open={isOpen}
			onOpenChange={setIsOpen}
		>
			<PopoverTrigger asChild>
				<Button
					className={activatorClassName}
					variant='ghost'
					icon
					{...buttonProps}
					onClick={(e) => {
						e.preventDefault()
						e.stopPropagation()
						setIsOpen(true)
					}}
				>
					<ShareIcon />
					<span className='sr-only'>{title}</span>
				</Button>
			</PopoverTrigger>

			<PopoverContent
				className='flex flex-col items-center gap-4 overflow-hidden md:flex-row'
				title={title}
			>
				<div className='flex items-center gap-2 overflow-hidden max-md:w-full md:flex-1'>
					<LinkIcon className='text-primary' />

					<div className='text-foreground/50 max-w-[300px] truncate border-b border-dashed text-sm'>
						{linkTocopy}
					</div>
				</div>

				<Button
					size='sm'
					variant='outline'
					className='max-md:w-full'
					onClick={() => {
						copyToClipboard(linkTocopy)
						onCopyBtnClick?.()
					}}
				>
					{isCopied ? t`URL copiée` : t`Copier l'URL`}
				</Button>
			</PopoverContent>
		</Popover>
	)
}
